<drag-scroll [scroll-x-wheel-enabled]="true" [drag-scroll-y-disabled]="false" #dragScroll>
  <div
    *ngFor="let device of installation.devices; index as index"
    drag-scroll-item
    class="tile-wrapper"
    (click)="changeSelectedDeviceIndex(index)"
    [class.selected-device]="index === selectedDeviceIndex"
  >
    <div class="tile">
      <div class="tile__header">
        <!-- Since backend doesnt provide standalone flag for a device check a whole installation data -->
        <!-- It won't work with multi gw + standalone -->

        <!-- 1 device standalone  -->
        <ng-container
          *ngIf="
            installation.devices.length === 1 && installation.isStandalone;
            else showRegularImages
          "
        >
          <img class="image" [src]="standaloneImagePath" />
        </ng-container>

        <!-- Show regular images -->
        <ng-template #showRegularImages>
          <img
            *ngIf="device.materialImage; else displayIcon"
            class="image"
            [src]="device.materialImage"
          />
          <ng-template #displayIcon>
            <mat-icon class="hide-image">hide_image</mat-icon>
          </ng-template>
        </ng-template>
        <div class="tile__header__labels">
          <div class="flex items-center">
            <h4 class="tile__header__labels__name">
              {{ device.marketingName ?? '' }}
            </h4>
            <img *ngIf="device.brandLogo" class="mt-[-2px]" src="{{ device.brandLogo }}" />
          </div>

          <span class="tile__header__labels__serial">
            <span>{{ device.vin }}</span>
          </span>
        </div>
      </div>
      <div class="tile__badges">
        <app-pill
          *ngIf="installation.aggregatedStatus | aggregatedStatusPill as aggregatedStatusPill"
          [type]="aggregatedStatusPill.pillType"
        >
          {{ aggregatedStatusPill.label | translate }}
        </app-pill>
        <app-pill
          *ngIf="installation.isSystemLocked"
          data-at-status-pill
          [type]="pillType.errorInverted"
        >
          {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.COLD_SYSTEM' | translate }}
        </app-pill>
        <app-pill
          *ngIf="kanbanBoardHelperService.isErrorSmartNote(device.smartNotes)"
          [type]="pillType.error"
        >
          {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.FAULT' | translate }}
        </app-pill>
        <ng-container *ngIf="device | dashboardAnomalyPill: true as anomalyPills">
          <app-pill *ngFor="let pill of anomalyPills" [type]="pill.pillType">
            {{ pill.label }}
          </app-pill>
        </ng-container>
        <app-pill
          *ngIf="device | dashboardOperatingMode as operatingModes"
          [type]="pillType.neutral"
        >
          {{ operatingModes }}
        </app-pill>
      </div>
    </div>
  </div>
</drag-scroll>
